import React, { Component } from 'react';

class ExtraBtns extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle">
                    <div>
                        To tailor content to user interests in Google Discover, Google classifies
                        all content into Categories and Entities. Entities represent specific
                        real-world concepts, such as people, places, organizations, and events, that
                        are mapped within Google’s knowledge graph. With over 9 billion entities and
                        growing, these identifiers enrich content understanding and relevance.
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraBtns;
